// extracted by mini-css-extract-plugin
export default {"afterpayPlacement":"I1-z"};